const CAPAKEY_BODY = '\\d{5}[A-Z]\\d{4}\\/\\d{2}[A-Z_]\\d{3}'
const PATRIMONIAL_IDENTIFIER_PATTERN = new RegExp(`^(${CAPAKEY_BODY})[-_]?(P\\d{4})$`)
const PARTITION_PATTERN = /^P\d{4}$/

export const normalizeCapakey = (value) => (value || '').replace(/\s+/g, '').trim().toUpperCase()

export const normalizePartition = (value) => (value || '').replace(/\s+/g, '').trim().toUpperCase()

export const isValidPartition = (value) => {
  const normalizedPartition = normalizePartition(value)
  return !normalizedPartition || PARTITION_PATTERN.test(normalizedPartition)
}

export const parsePropertyIdentifier = (value) => {
  const normalizedIdentifier = normalizeCapakey(value)
  const match = normalizedIdentifier.match(PATRIMONIAL_IDENTIFIER_PATTERN)

  if (!match) {
    return {
      cadastralNr: normalizedIdentifier,
      partitionNr: '',
    }
  }

  return {
    cadastralNr: match[1],
    partitionNr: match[2],
  }
}

export const formatPropertyIdentifier = (cadastralNr, partitionNr) => {
  const normalizedCapakey = normalizeCapakey(cadastralNr)
  const normalizedPartition = normalizePartition(partitionNr)
  return normalizedPartition ? `${normalizedCapakey}-${normalizedPartition}` : normalizedCapakey
}
